// components
import { DashboardHeader } from "./Header";
import { DashboardOutlet } from "./Outlet";
import { DashboardBottomNavigation } from "./BottomNavigation";
import { DesktopSidebar } from "./Sidebar";
// @mui
import Box from "@mui/material/Box";
// hooks
import { useWindowDimensions } from "hooks/useWindowDimensions";
// config
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { paths } from "routes/paths";
import { DashboardHorizontalNavbar } from "./Navbar";

interface StyledRootProps {
  screenHeight: number;
}

const StyledRoot = styled(Box, {
  shouldForwardProp: (prop: PropertyKey) => prop !== "screenHeight",
})<StyledRootProps>(({ theme }) => ({
  width: "100%",
  display: "flex",
  height: "100%",
  flexDirection: "column",
  overflowX: "hidden",
  overflowY: "auto",
  backgroundColor: theme.palette.background.default,
  position: "relative",
  WebkitOverflowScrolling: "touch",
}));

export const MainLayout = () => {
  const { height } = useWindowDimensions();
  const { pathname } = useLocation();
  // Remove dashboard from navbar list - dashboard shouldn't have filters
  const hasNavbar = [
    paths.calendar.calendar,
    paths.pendingActions.list,
  ].includes(pathname);

  return (
    <>
      <StyledRoot screenHeight={height}>
        <DesktopSidebar />
        <Box
          sx={{
            marginLeft: { xs: 0, md: "240px" },
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minWidth: 0,
            maxWidth: { xs: "100%", md: "calc(100% - 240px)" },
          }}
        >
          <DashboardHeader />
          {hasNavbar && <DashboardHorizontalNavbar />}
          <DashboardOutlet />
        </Box>
      </StyledRoot>
      <DashboardBottomNavigation />
    </>
  );
};
